import script from "./CompareModeVideos.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompareModeVideos.vue?vue&type=script&setup=true&lang=ts"

import "./CompareModeVideos.vue?vue&type=style&index=0&id=0727538e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0727538e"]])

export default __exports__